export const registerTour = {
  key: "register",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="register-name"]',
      content: t("Tour_Register_Name"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="register-email"]',
      content: t("Tour_Register_Email"),
      placement: "bottom",
    },
    {
      target: '[data-tour="register-password"]',
      content: t("Tour_Register_Password"),
      placement: "bottom",
    },
    {
      target: '[data-tour="register-submit"]',
      content: t("Tour_Register_Submit"),
      placement: "top",
    },
    {
      target: '[data-tour="register-login-link"]',
      content: t("Tour_Register_LoginLink"),
      placement: "top",
    },
    {
      target: '[data-tour="help-button"]',
      content: t("Tour_HelpButtonHint"),
      placement: "bottom",
    },
  ],
};
